import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { postRequest } from 'src/lib/core/api-client'
import { useLocale } from 'src/lib/hooks/useLocal'
import { apiURI } from 'src/lib/utils/constants'
import { validateEmail } from 'src/lib/utils/helpers'

const EmailExpired = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { email, token } = router.query

  useEffect(() => {
    if (!Boolean(validateEmail(String(email))) && !Boolean(token)) {
      router.replace('/auth/login')
    } else {
      resendInvitation()
    }
  }, [email, token])

  const resendInvitation = async () => {
    if (!Boolean(token)) return
    const payload = { invitation_id: token }
    try {
      await postRequest('/merchant-invitation/resend', apiURI.AUTH_ENGINE, payload)
    } catch (error: any) {
      console.error(error)
    }
  }

  return (
    <div className='flex flex-col gap-12 min-w-[380px]'>
      <div className='flex flex-col gap-8'>
        <h2 className='text-display-xs-semibold text-zinc-700 items-center text-center'>{t('expired_email')}</h2>
        <p className='text-text-xs-regular text-zinc-500 text-center'>{t('expired_email_text', { email: email })}</p>
      </div>
    </div>
  )
}

export default EmailExpired
